<template>
  <div ref="place-category-dropdown" class="place-category-dropdown">
    <div class="selected-place-category-row" @click="clickInput">
      <div class="icon-category-container" v-if="selectedPlaceCategoryIndex !== undefined">
        <img :src="placeCategoryList[selectedPlaceCategoryIndex].iconfilename_hd">
      </div>
      <div class="name" v-if="selectedPlaceCategoryIndex !== undefined">
        {{ $i18n.locale === 'th' ? placeCategoryList[selectedPlaceCategoryIndex].description_th : placeCategoryList[selectedPlaceCategoryIndex].description_en }}
      </div>
      <div class="placeholder" v-if="selectedPlaceCategoryIndex === undefined">
        {{ `${$t('PlaceCategoryDropdown.select')} *` }}
      </div>
      <img @click="clickInput" class="arrow-dropdown" :class="{active: showDropdown}" :src="util.getImagePath('arrow_up_blue@2x.png')" :srcset="util.getImageSet('arrow_up_blue')">
    </div>
    <div class="dropdown" v-show="placeCategoryList.length > 0 && showDropdown">
      <input type="search" v-model="keyword" @keydown.down="down" @keydown.up="up">
      <div ref="place-category-list" class="place-category-list">
        <div class="place-category-row"
          v-for="placeCategory in filteredPlaceCategoryList"
          :key="placeCategory.id" @click="selectPlaceCategory(placeCategory.id)"
          :class="{'selected-row': placeCategory.id === selectedPlaceCategoryId}">
          <div class="icon-category-container">
            <img :src="placeCategory.iconfilename_hd" loading="lazy">
          </div>
          <div class="name">
            {{ $i18n.locale === 'th' ? placeCategory.description_th : placeCategory.description_en }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PlaceCategoryDropdown',
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          id: ''
        }
      }
    }
  },
  data () {
    return {
      keyword: '',
      placeCategoryList: [],
      showDropdown: false,
      selectedPlaceCategoryId: this.value.id,
      selectedPlaceCategoryIndex: undefined
    }
  },
  mounted () {
    var self = this
    self.$root.$on('clickOnWindow', self.clickOnWindow)
    self.getCategoryList()
  },
  computed: {
    filteredPlaceCategoryList () {
      var self = this
      return self.placeCategoryList.filter(placeCategory => {
        var isMatchTh = placeCategory.description_th.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
        var isMatchEn = placeCategory.description_en.toLowerCase().indexOf(self.keyword.toLowerCase()) !== -1
        var isEmptyKeyword = self.keyword === ''
        return isMatchTh || isMatchEn || isEmptyKeyword
      })
    }
  },
  methods: {
    clickOnWindow (e) {
      var self = this
      if (self.placeCategoryList.length > 0 && self.showDropdown) {
        self.showDropdown = (self.$refs['place-category-dropdown'] === e.target || self.$refs['place-category-dropdown'].contains(e.target))
      }
    },
    getCategoryList () {
      var self = this
      self.pp.getPlaceCategories(undefined, undefined, self.$i18n.locale, (result) => {
        self.placeCategoryList = result.data
        if (self.placeCategoryList.length > 0) {
          // self.selectedPlaceCategoryId = self.placeCategoryList[0].id
          // self.selectedPlaceCategoryIndex = 0
          self.selectedPlaceCategoryId = '-1'
          self.selectedPlaceCategoryIndex = self.placeCategoryList.map(c => c.id).indexOf('-1')
        }
      })
    },
    clickInput () {
      var self = this
      self.showDropdown = !self.showDropdown
    },
    selectPlaceCategory (placeCategoryId) {
      var self = this
      var index = self.placeCategoryList.map(placeCategory => { return placeCategory.id }).indexOf(placeCategoryId)
      if (index !== -1) {
        self.selectedPlaceCategoryId = placeCategoryId
        self.selectedPlaceCategoryIndex = index
      }
      self.showDropdown = false
    },
    down () {
      var self = this
      if (self.selectedPlaceCategoryId !== undefined) {
        var index = self.filteredPlaceCategoryList.map(placeCategory => { return placeCategory.id }).indexOf(self.selectedPlaceCategoryId)
        if (index !== -1) {
          index++
          if (index >= self.filteredPlaceCategoryList.length) {
            self.selectedPlaceCategoryIndex = self.filteredPlaceCategoryList.length - 1
          } else {
            self.selectedPlaceCategoryIndex = index
          }
          self.selectedPlaceCategoryId = self.filteredPlaceCategoryList[self.selectedPlaceCategoryIndex].id
        }
      } else {
        self.selectedPlaceCategoryIndex = 0
        self.selectedPlaceCategoryId = self.filteredPlaceCategoryList[self.selectedPlaceCategoryIndex].id
      }
    },
    up () {
      var self = this
      if (self.selectedPlaceCategoryId !== undefined) {
        var index = self.filteredPlaceCategoryList.map(placeCategory => { return placeCategory.id }).indexOf(self.selectedPlaceCategoryId)
        if (index !== -1) {
          index--
          if (index < 0) {
            self.selectedPlaceCategoryIndex = 0
          } else {
            self.selectedPlaceCategoryIndex = index
          }
          self.selectedPlaceCategoryId = self.filteredPlaceCategoryList[self.selectedPlaceCategoryIndex].id
        }
      } else {
        self.selectedPlaceCategoryIndex = self.filteredPlaceCategoryList.length - 1
        self.selectedPlaceCategoryId = self.filteredPlaceCategoryList[self.selectedPlaceCategoryIndex].id
      }
    },
    updateScrollTop () {
      // var selectedRow = document.querySelector('.selected-row')
      // if (selectedRow) {
      //   selectedRow.scrollIntoView()
      // }
    }
  },
  watch: {
    showDropdown () {
      var self = this
      self.$nextTick(() => {
        if (self.showDropdown) {
          self.updateScrollTop()
        }
      })
    },
    selectedPlaceCategoryIndex () {
      var self = this
      self.$nextTick(() => {
        self.updateScrollTop()
        var index = self.placeCategoryList.map(placeCategory => { return placeCategory.id }).indexOf(self.selectedPlaceCategoryId)
        self.$emit('input', self.placeCategoryList[index])
      })
    },
    placeCategoryList () {
      var self = this
      self.$nextTick(() => {
        self.selectPlaceCategory(self.value.id)
      })
    }
  },
  beforeDestroy () {
    var self = this
    self.$root.$off('clickOnWindow')
  }
}
</script>

<style scoped>
  .place-category-dropdown {
    position: relative;
  }

  .selected-place-category-row {
    width: calc(100% - 16px);
    height: 100%;
    border: none;
    background-color: transparent;
    box-sizing: border-box;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    cursor: pointer;
  }

  .selected-place-category-row > .icon-category-container {
    height: 16px;
    width: 16px;
    padding: 0px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
  }

  .selected-place-category-row > .icon-category-container > img {
    max-height: 16px;
    max-width: 16px;
  }

  .selected-place-category-row > .name {
    width: calc(100% - 26px);
    padding: 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-size: 16px;
    text-indent: 2px;
    font-family: Default-PromptPai-Medium;
    line-height: 32px;
  }

  .selected-place-category-row > .placeholder {
    width: 100%;
    padding: 2px 0px 0px 0px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    font-size: 15px;
    color: rgb(175, 175, 175);
  }

  .arrow-dropdown {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 10;
    width: 16px;
    height: 16px;
    transform: rotate(180deg);
  }

  .arrow-dropdown.active {
    transform: rotate(0deg);
  }

  .dropdown {
    position: absolute;
    background-color: rgb(255, 255, 255);
    width: 100%;
    left: 0px;
    padding: 10px;
    box-sizing: border-box;
    z-index: 20;
    box-shadow: 0px 4px 4px 4px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
  }

  .dropdown > input[type=search] {
    border: 1px solid rgb(120, 120, 120);
    width: 100%;
    height: 36px;
    padding: 5px;
    border-radius: 4px;
    font-size: 16px;
    text-indent: 2px;
    font-family: Default-PromptPai-Medium;
    line-height: 36px;
  }

  .dropdown > input[type=search]::-webkit-search-cancel-button{
    appearance: auto;
  }

  .place-category-list {
    margin-top: 5px;
    overflow-y: auto;
    max-height: 200px;
  }

  .place-category-list::-webkit-scrollbar {
    background-color: rgb(251, 251, 251);
  }
  .place-category-list::-webkit-scrollbar-thumb {
    border: 2px solid rgb(251, 251, 251);
  }

  .place-category-row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 36px;
    margin: 4px 0px;
    cursor: pointer;
  }

  .place-category-row > .icon-category-container {
    height: 36px;
    width: 36px;
    padding: 8px;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .place-category-row > .icon-category-container > img {
    max-height: 16px;
    max-width: 16px;
  }

  .place-category-row > .name {
    width: 100%;
    padding: 2px 0px 0px 10px;
    font-size: 16px;
  }

  .selected-row {
    background-color: rgb(227, 227, 227);
  }
</style>



// WEBPACK FOOTER //
// src/components/PlaceCategoryDropdown.vue